// extracted by mini-css-extract-plugin
export default {"root":"EmcA71TaOw9I4D8"};